import { Box } from "@mui/material";
import { CoverageArea } from "../../interfaces/job.interfaces";
import { JobCoverageArea } from "../coverage-area/JobCoverageArea";
import { JobScopeOfWork } from "../scope-of-work/JobScopeOfWork";

interface Props {
  jobId: string | number;
  coverageArea?: CoverageArea | null;
  clientUid?: string | null;
}

export function JobContextRow({ jobId, coverageArea, clientUid }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        gap: 3,
        px: 3,
        flexDirection: { xs: "column", md: "row" },
        alignItems: "stretch",
      }}
    >
      <JobCoverageArea coverageArea={coverageArea} fullWidth={false} jobId={jobId} clientUid={clientUid} />
      <JobScopeOfWork jobId={jobId} />
    </Box>
  );
}
